import { wrap } from "shared/utils/wrapper";

/** trims any number of the given character from both ends of then given str */
export function trimChr(str: string, chr: string): string {
    function triml(str: string): string {
        if (str.at(0) == chr) return triml(str.slice(1));
        return str;
    }

    function trimr(str: string): string {
        if (str.at(-1) == chr) return trimr(str.substring(0, str.length - 1));
        return str;
    }

    return wrap(str).then(triml).then(trimr).take();
}
